import Event from '../../core/Event';
import { ArticleOrderDraft } from '../../../domain/Order';

export default class OrderSetBaseOnLiabilitySucceed extends Event {
    public static type = 'OrderSetBaseOnLiabilitySucceed';

    constructor(public readonly articleOrderDrafts: ArticleOrderDraft[]) {
        super(OrderSetBaseOnLiabilitySucceed.type);
    }
}



// WEBPACK FOOTER //
// ./src/application/order/events/OrderSetBaseOnLiabilitySucceed.ts